import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { ArrowLeft } from 'lucide-react';
import { trackEvent } from '../../lib/analytics';

const ShippingReturns: React.FC = () => {
  useEffect(() => {
    trackEvent('legal_page', 'visit', 'shipping_returns');
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button 
            variant="ghost" 
            size="sm" 
            className="mb-6"
            leftIcon={<ArrowLeft size={16} />}
            onClick={() => trackEvent('navigation', 'back_from_shipping', 'home')}
          >
            Back to Home
          </Button>
        </Link>
        
        <Card>
          <div className="p-6">
            <h1 className="text-2xl font-bold text-primary-800 font-display mb-6">Shipping & Returns Policy</h1>
            
            <div className="space-y-6 text-neutral-700">
              <section>
                <h2 className="text-xl font-semibold mb-3">1. Digital Services</h2>
                <p>
                  AI Pandit Ji provides digital astrological services delivered instantly through our online platform. There are no physical products to ship, and all services are delivered electronically.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">2. Subscription Policy</h2>
                <p className="mb-3">
                  We offer various subscription plans for our premium services:
                </p>
                <ul className="list-disc pl-6 mb-3 space-y-1">
                  <li>Monthly subscription: Automatically renews every month until cancelled</li>
                  <li>Yearly subscription: Automatically renews every year until cancelled</li>
                  <li>Lifetime access: One-time payment for unlimited access</li>
                </ul>
                <p>
                  You can manage or cancel your subscription at any time through your account settings or by contacting our support team.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">3. Refund Policy</h2>
                <p className="mb-3">
                  As our services are digital in nature and delivered immediately upon payment, we generally do not offer refunds. However, we consider refund requests in the following circumstances:
                </p>
                <ul className="list-disc pl-6 mb-3 space-y-1">
                  <li>Technical issues that prevent access to the purchased services</li>
                  <li>Duplicate charges for the same service</li>
                  <li>Services significantly different from what was described</li>
                </ul>
                <p>
                  Refund requests must be submitted within 7 days of purchase. Each request is reviewed on a case-by-case basis.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">4. Cancellation Policy</h2>
                <p>
                  You may cancel your subscription at any time. Once cancelled, you will continue to have access to premium features until the end of your current billing period. After that, your account will revert to the free tier with limited access.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">5. Contact for Refunds or Cancellations</h2>
                <p>
                  For any refund requests or assistance with cancellation, please contact our support team at <a 
                    href="mailto:theaipanditji@gmail.com" 
                    className="text-primary-600 hover:underline"
                    onClick={() => trackEvent('user_engagement', 'email_click', 'shipping_contact')}
                  >theaipanditji@gmail.com</a>.
                </p>
              </section>
            </div>
            
            <div className="mt-8 text-sm text-neutral-500 text-center">
              Last Updated: June 10, 2025
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ShippingReturns;